import base from './base';
export default Object.assign(Object.assign({}, base), { name: 'Honda' });
